import { Box, Button, Text } from '@chakra-ui/react'
import { useState } from 'react'
import SingleReportByID from 'routes/common/SingleReportByID'

const reportIdByDisease: Record<string, string> = {
  Mpox: '1535',
  Botulism: '1699',
}
const LatestAnalysis = ({ disease }: { disease: string }) => {
  const [readMore, setReadMore] = useState(false)
  const reportId = reportIdByDisease[disease] || '1535' // Default to Mpox if disease not found
  return (
    <Box
      border={'1px solid'}
      borderColor='gray3'
      borderRadius='8px'
      p={4}
      position={'relative'}
      overflowY={'hidden'}
      fontSize='sm'
      w='100%'
      h={readMore ? '100%' : '260px'}
    >
      <Text
        position={'absolute'}
        top={3}
        fontWeight={'semibold'}
        fontSize={'lg'}
      >
        Read the Latest {disease} report
      </Text>
      <SingleReportByID id={reportId} noBorder />
      <Box pos='absolute' left='50%' bottom='8px' bg='white'>
        <Button variant='outline' onClick={() => setReadMore((x) => !x)}>
          {readMore ? 'Read Less' : 'Read More'}
        </Button>
      </Box>
    </Box>
  )
}

export default LatestAnalysis
